import type { CornerValues, Corners } from '@sites/entity-core';

/** Updaters for a `corners` node — see `withSpacingSides` for why they are updaters. */

/** The four corners live in one leaf, so a single-corner edit merges into it. */
export const withCorners =
    (patch: Partial<CornerValues>) =>
    (current: Corners | undefined): Corners =>
        ({ ...current, value: { ...current?.value, ...patch } }) as Corners;
